import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';

import { RemedyBreadcrumbs } from '@/features/code-remedy/RemedyBreadcrumbs';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/code-modernization')({
  component: CodeRemedyLayout,
});

function CodeRemedyLayout() {
  const pathname = useLocation({ select: (l) => l.pathname });
  const isSubRoute = /\/code-modernization\/.+/.test(pathname);

  return (
    <PageLayout header={isSubRoute} classes={{ page: 'flex' }}>
      {isSubRoute ? <RemedyBreadcrumbs /> : <title>Code Modernization</title>}
      <Outlet />
    </PageLayout>
  );
}
